import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Users, Building2, Eye, UserX } from 'lucide-react';
import { STATUS_COLORS, STATUS_LABELS } from './adminUtils';

export const UsersTab = ({ users, onView, onDeleteClick }) => (
  <Card className="bg-slate-800/50 border-slate-700" data-testid="admin-users-tab">
    <CardContent className="p-6">
      <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
        <Users className="h-5 w-5 text-[#3B82F6]" />
        Registered Users ({users.length})
      </h3>
      <div className="space-y-3">
        {users.map((user) => (
          <div
            key={user.id}
            className="flex items-center justify-between p-4 bg-slate-700/30 rounded-lg hover:bg-slate-700/50 transition-colors"
          >
            <div
              className="flex items-center gap-4 flex-1 cursor-pointer"
              onClick={() => onView(user)}
            >
              <div className="w-10 h-10 rounded-full bg-[#3B82F6]/20 flex items-center justify-center">
                <Building2 className="h-5 w-5 text-[#3B82F6]" />
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <p className="text-white font-medium">{user.company_name}</p>
                  <Badge className={STATUS_COLORS[user.followup_status || 'new']} variant="outline">
                    {STATUS_LABELS[user.followup_status || 'new']}
                  </Badge>
                </div>
                <p className="text-slate-500 text-sm">{user.person_name} • {user.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-slate-500 text-sm">{user.country}</span>
              <Button
                variant="ghost"
                size="sm"
                data-testid={`view-user-${user.id}`}
                onClick={() => onView(user)}
                className="text-slate-400 hover:text-white"
              >
                <Eye className="h-4 w-4" />
              </Button>
              <Button
                variant="ghost"
                size="sm"
                data-testid={`delete-user-${user.id}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteClick(user);
                }}
                className="text-slate-400 hover:text-red-500 hover:bg-red-500/10"
              >
                <UserX className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
